export const syncDoctorProfileUserState = ({
  profileData,
  updateUserDetails,
  updateStatus,
  storage = globalThis.localStorage,
}) => {
  updateUserDetails(profileData);

  const isCompleted = Boolean(profileData?.users?.is_completed);
  updateStatus(isCompleted);
  storage?.setItem("isAciveDoctorAcc", isCompleted ? "1" : "0");

  return isCompleted;
};
